exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  padding: 15px; }\n  @media screen and (max-width: 767px) {\n    .wrapper {\n      padding: 15px 10px; } }\n  .wrapper .row {\n    padding: 0 15px; }\n    .wrapper .row .col-xs-10,\n    .wrapper .row .col-xs-2 {\n      padding: 0; }\n    @media screen and (max-width: 767px) {\n      .wrapper .row:last-child {\n        padding: 0 15px; } }\n\n.box {\n  display: -ms-flexbox;\n  display: flex; }\n  .box i {\n    padding-right: 10px; }\n  .box .box-text {\n    display: -ms-grid;\n    display: grid; }\n    .box .box-text .title {\n      display: inline; }\n    .box .box-text .sub-title {\n      color: #6b778c; }\n\n.toggle-button {\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subscription/subscription.component.scss
// module id = 955
// module chunks = 22